export const registerPageStyles = {
  page: {
    minHeight: '100%',
    position: 'relative' as const,
    overflow: 'hidden' as const,
    background: 'linear-gradient(180deg, #f4f6fb 0%, #eef2f8 100%)',
    padding: '24px 18px 32px',
  },
  glowPrimary: {
    position: 'absolute' as const,
    top: -96,
    left: -64,
    width: 280,
    height: 280,
    borderRadius: '50%',
    background: 'rgba(91, 155, 255, 0.14)',
    filter: 'blur(36px)',
  },
  glowSecondary: {
    position: 'absolute' as const,
    right: -70,
    bottom: 12,
    width: 320,
    height: 320,
    borderRadius: '50%',
    background: 'rgba(23, 105, 255, 0.1)',
    filter: 'blur(42px)',
  },
  shell: {
    position: 'relative' as const,
    zIndex: 1,
    width: '100%',
    maxWidth: 430,
    margin: '0 auto',
  },
  backRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between' as const,
    marginBottom: 26,
  },
  backButton: {
    width: 38,
    height: 38,
    borderRadius: '50%',
    border: '1px solid rgba(17, 24, 39, 0.08)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#3f3f46',
    fontSize: 16,
    background: 'rgba(255, 255, 255, 0.9)',
    boxShadow: '0 10px 24px rgba(15, 23, 42, 0.08)',
    cursor: 'pointer',
  },
  badge: {
    padding: '8px 14px',
    borderRadius: 999,
    background: 'rgba(255, 255, 255, 0.72)',
    color: '#1769ff',
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 0.6,
    textTransform: 'uppercase' as const,
  },
  title: {
    fontSize: 42,
    lineHeight: '48px',
    fontWeight: 800,
    color: '#27272a',
    textAlign: 'center' as const,
    marginBottom: 10,
    letterSpacing: -1.2,
  },
  subtitle: {
    fontSize: 14,
    lineHeight: '22px',
    color: '#71717a',
    textAlign: 'center' as const,
    marginBottom: 24,
  },
  heroCard: {
    borderRadius: 30,
    padding: '18px 18px 16px',
    background: 'rgba(255, 255, 255, 0.72)',
    border: '1px solid rgba(255, 255, 255, 0.65)',
    boxShadow: '0 18px 40px rgba(15, 23, 42, 0.08)',
    backdropFilter: 'blur(20px)',
    marginBottom: 18,
  },
  heroRow: {
    display: 'flex',
    gap: 10,
    marginBottom: 12,
  },
  heroItem: {
    flex: 1,
    borderRadius: 20,
    background: '#ffffff',
    padding: '14px 12px',
    textAlign: 'center' as const,
  },
  heroValue: {
    fontSize: 14,
    fontWeight: 700,
    color: '#111827',
  },
  heroLabel: {
    fontSize: 11,
    color: '#94a3b8',
    marginTop: 6,
  },
  heroHint: {
    fontSize: 12,
    lineHeight: '18px',
    color: '#64748b',
    textAlign: 'center' as const,
  },
  formCard: {
    background: 'rgba(255, 255, 255, 0.92)',
    borderRadius: 32,
    padding: '26px 18px 18px',
    boxShadow: '0 24px 48px rgba(15, 23, 42, 0.1)',
    backdropFilter: 'blur(18px)',
  },
  sectionTitle: {
    fontSize: 30,
    fontWeight: 800,
    color: '#27272a',
    marginBottom: 8,
    textAlign: 'center' as const,
  },
  sectionSubtitle: {
    fontSize: 13,
    color: '#71717a',
    textAlign: 'center' as const,
    marginBottom: 22,
  },
  inputShell: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    minHeight: 52,
    borderRadius: 999,
    padding: '0 16px',
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.8)',
  },
  inputIcon: {
    color: '#a1a1aa',
    fontSize: 16,
  },
  input: {
    '--font-size': '15px',
    '--color': '#18181b',
    width: '100%',
  },
  submitButton: {
    '--border-radius': '999px',
    '--text-color': '#fff',
    height: 50,
    fontSize: 15,
    fontWeight: 700,
    boxShadow: '0 14px 28px rgba(23, 105, 255, 0.22)',
  },
  footer: {
    marginTop: 18,
    textAlign: 'center' as const,
    fontSize: 13,
    color: '#71717a',
  },
  footerLink: {
    color: '#1769ff',
    marginLeft: 4,
    fontWeight: 700,
  },
};
